import axios from 'axios';
import { translateStudioError, STUDIO_LANG_KEY } from './studioI18n';

export const STUDIO_TOKEN_KEY = 'studio_access_token';
export { compressImage } from '../sales/salesApi';

export const studioApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/studio` });
studioApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(STUDIO_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
studioApi.interceptors.response.use((r) => r, (error) => {
  if (error?.response?.status === 401 && !String(error.config?.url || '').includes('/auth/')) {
    localStorage.removeItem(STUDIO_TOKEN_KEY);
    window.dispatchEvent(new Event('studio-logout'));
  }
  return Promise.reject(error);
});

export function apiError(err, fallback = 'Something went wrong') {
  const lang = localStorage.getItem(STUDIO_LANG_KEY) || 'pt-BR';
  const detail = err?.response?.data?.detail;
  if (!detail) return translateStudioError(err?.message || fallback, lang);
  if (typeof detail === 'string') return translateStudioError(detail, lang);
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return translateStudioError(detail?.msg || String(detail), lang);
}

export const fileUrl = (fileId, size = 'full') => `${process.env.REACT_APP_BACKEND_URL}/api/studio/files/${fileId}?size=${size}&auth=${encodeURIComponent(localStorage.getItem(STUDIO_TOKEN_KEY) || '')}`;
